/**
 * Initial state
 */
const initialState = {
    searchData:{
        wheelsOnCar: [],
        wheelsOnStation: [],
        wheelsOnDelivery: [],
        wheelsInWarehouse: [],
        wheelsAtWheelDistributor:[]
    },
    loading:false
};

/**
 * User reducer
 */
export default function (state = initialState, action) {

    const {type, payload} = action;
    switch (type) {
        case 'WHEELS_RESET':
            return initialState;
        case 'WHEELS_SHIFT_SUCCESS':
            return {
                ...state,
            }
        case 'WHEELS_SHIFT_FAILURE':
            return {
                ...state,
            }



        case 'WHEELS_REVERSE_SHIFT_SUCCESS':
            return {
                ...state,
            }
        case 'WHEELS_REVERSE_SHIFT_FAILURE':
            return {
                ...state,
            }



        case 'WHEELS_ADMIN_SHIFT_SUCCESS':
            return {
                ...state,
            }
        case 'WHEELS_ADMIN_SHIFT_FAILURE':
            return {
                ...state,
            }


        case 'WHEELS_SEARCH_REQUEST':
            return {
                ...state,
                loading: true
            }
        case 'WHEELS_SEARCH_SUCCESS':
            return {
                ...state,
                searchData: payload,
                loading: false
            }
        case 'WHEELS_SEARCH_FAILURE':
            return {
                ...state,
                searchData: payload,
                loading: false
            }


        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/wheels.js